module.exports = __webpack_public_path__ + "img/lost.b56a3c85.svg";